import script from "./FinalSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalSetting.vue?vue&type=script&setup=true&lang=ts"

import "./FinalSetting.vue?vue&type=style&index=0&id=45cd1261&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45cd1261"]])

export default __exports__